import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { importsSalesforceSummaryGetSlice } from './get';

export const importsSalesforceSummaryReducers = combineReducers({
	get: importsSalesforceSummaryGetSlice.asyncReducers
});

export const importsSalesforceSummaryWatchers = combineAllWatchers([
	importsSalesforceSummaryGetSlice.asyncWatchers
]);
